import { render, staticRenderFns } from "./ArrowPhotoOverlayIcon.vue?vue&type=template&id=27bcaf2f&scoped=true"
import script from "./ArrowPhotoOverlayIcon.vue?vue&type=script&lang=ts"
export * from "./ArrowPhotoOverlayIcon.vue?vue&type=script&lang=ts"
import style0 from "./ArrowPhotoOverlayIcon.vue?vue&type=style&index=0&id=27bcaf2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bcaf2f",
  null
  
)

export default component.exports